import axios from "axios";
import API_BASE_URL from "../config/api";

// Base URL for your Flask backend
const BASE_URL = API_BASE_URL;

// Fetch all reviewers
export const getReviewers = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/reviewers`);
    return response.data;  // assuming Flask returns JSON
  } catch (error) {
    console.error("Error fetching reviewers:", error);
    return [];
  }
};

// Create a new reviewer
export const createReviewer = async (reviewerData) => {
  try {
    const response = await axios.post(`${BASE_URL}/reviewers`, reviewerData);
    return response.data;
  } catch (error) {
    console.error("Error creating reviewer:", error);
    throw error;
  }
};

// Update a reviewer
export const updateReviewer = async (id, reviewerData) => {
  try {
    const response = await axios.put(`${BASE_URL}/reviewers/${id}`, reviewerData);
    return response.data;
  } catch (error) {
    console.error("Error updating reviewer:", error);
    throw error;
  }
};

// Delete a reviewer
export const deleteReviewer = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/reviewers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting reviewer:", error);
    throw error;
  }
};
